import {createStore} from 'redux';

import app from './../Reducers/app.js'

const store = process.env.NODE_ENV === 'development' ? createStore(app, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()) : createStore(app)
export default store;
